import { useTripStore } from './trip.store';

export const getTrip = useTripStore.getState().getTrip;
export const saveScreeningResultAction = useTripStore.getState().saveScreeningResult;
